// @flow
import {FAMILY_FRIENDLY_FILTER_NAME} from '../constants';

type SearchParams = {
    +inputParams: {filter?: ?(string[])}
};

export default function isFamilyFriendlySelected({
    inputParams: {filter: filterInputParams}
}: SearchParams): boolean {
    return (filterInputParams || []).includes(FAMILY_FRIENDLY_FILTER_NAME);
}
